export * from './vorlage-filter.component';
export * from './vorlage-filter.component.module';